<template>
    <div class="gcmcn-card">
        <div class="taker-information-container">
            <div class="taker-information">
                <div>
                    <img :src="taker.logo ? taker.logo : defaultTakerLogo">
                </div>
                <div class="taker-information-name">
                    {{ taker.name}}
                </div>
            </div>
            <div>
                <btn-manage-right
                    :feed-finished="feedFinished"
                    :broadcast-right="relatedBroadcastRight"
                    :feed-confirmed="feedConfirmed"
                    :disabled-right-button="disabledRightButton"
                    @create-broadcast-right="createBroadcastRight"
                    @delete-broadcast-right="removeBroadcastRight"
                ></btn-manage-right>
            </div>
        </div>
        <div class="see-more-link" @click="showTaker">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>
import BtnManageRight from '../../partials/manage-broadcast-right.vue';
export default {

    components: {
        BtnManageRight
    },

    props: {
        taker: {
            type: Object,
            required: true,
        },
        broadcastRight: {
            type: Array,
            required: true,
        },
        feedConfirmed: {
            type: Boolean,
            required: true,
        },
        feedFinished: {
            type: Boolean,
            required: false,
            default: false
        },
        resourceConfigurations: {
            type: Array,
            default: ()=>{
                return [];
            },
        },
        feedRelatedToFeedResource: {
            type: Boolean,
            default: false
        },
    },

    data (){
        return {
            feedConfigured: true,
            hasBroadcastRight: false,
            defaultTakerLogo: '../../../../static/image/default-taker-logo.png'
        };
    },

    computed: {
        relatedBroadcastRight (){
            return this.broadcastRight.find(
                br => br.revoked === false && br.taker_uid === this.taker.uid
            ) || null;
        },
        takerRelatedResourceConfiguration(){
            return this.resourceConfigurations.find(conf => conf.taker_uid === this.taker.uid);
        },
        disabledRightButton(){
            if(this.feedFinished){
                return true;
            }
            if(this.feedRelatedToFeedResource){
                if (this.takerRelatedResourceConfiguration && ['CONNECTED', 'STOPPING', 'STOPPED', 'STARTING'].includes(this.takerRelatedResourceConfiguration.status)){
                    return false;
                }
                return true;
            }
            return false;
        },
    },

    mounted (){

    },

    methods: {
        showTaker (){
            this.$router.push({
                name: 'takers',
                params: { takerUid: this.taker.uid}
            });
        },
        createBroadcastRight (){
            this.$emit('create-broadcast-right', this.taker.uid);
        },
        removeBroadcastRight (){
            this.$emit('delete-broadcast-right', this.taker.uid);
        },
    },
};
</script>

<style lang="scss">
.feed-takers{
    .gcmcn-card{
        margin-bottom: 10px;
    }
    .taker-information-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .taker-information{
        flex-basis: 70%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .taker-information-name{
            flex-grow: 1;
            margin-left: 30px;
        }
        img{
            flex-basis: 20%;

        }
    }
    img{
        width: 45px;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/taker.vue